import { CoreAPI, createCommonSalesMethods } from '@hero/sdk-core';

/**
 * Sales API namespace for the Carrier SDK. Subscriptions + billing +
 * features for the org. Shared shape — every dashboard re-exports
 * `createCommonSalesMethods`.
 */
export function createSalesAPI(coreAPI: CoreAPI) {
  return {
    ...createCommonSalesMethods(coreAPI),
  };
}
